import type { ReactNode } from "react";
import useIsCareerServicesDashboardEnabled from "../_hooks/useIsCareerServicesDashboardEnabled";

type CareerServicesDashboardGateProps = {
  children: ReactNode;
};

export default function CareerServicesDashboardGate({ children }: CareerServicesDashboardGateProps) {
  const isEnabled = useIsCareerServicesDashboardEnabled();

  return isEnabled ? children : null;
}
